import React, { Component } from "react";

import { Row, Col } from "reactstrap";
import { Tabs } from "antd";

import Anetaret from "./DynamicDeputet";
import "../../styles/components/Dynamic/DynamicTabs.css";

const { TabPane } = Tabs;
class DynamicTabs extends Component {
  constructor() {
    super();
    this.state = { activeTab: "0" };
  }
  toggle(tab) {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab
      });
    }
  }

  render() {
    const { data } = this.props;
    let a = Object.assign({}, data.anetaret);
    console.log(a[0], "here");
    let booli = false;
    if (a[0]) {
      booli = true;
    }
    return (
      <div>
        <div className="textParts">
          <div className="dynamicTabsTitle">
            {data.emri ? <h1>{data.emri}</h1> : null}
          </div>
          <hr className="dynamicTabsHr" />
          {data.pershkrimi ? (
            <p className="dynamicTabsDescr">{data.pershkrimi}</p>
          ) : null}
          <div className="nav-tabs-wrapper">
            <Tabs defaultActiveKey="0" onChange={() => {}}>
              {data.kategorite &&
                data.kategorite.map((tab, index) => {
                  return (
                    <TabPane sty tab={tab.emri} key={index}>
                      <div className="insideTabDesc">{tab.pershkrimi}</div>
                    </TabPane>
                  );
                })}
              {booli ? (
                <TabPane tab={"Anetaret"} key={999}>
                  <Row>
                    <Col
                      className="content-tab-category"
                      style={{ padding: "10px" }}
                      sm="12"
                    >
                      <Anetaret data={data.anetaret} />
                    </Col>
                  </Row>
                </TabPane>
              ) : null}
            </Tabs>
          </div>
        </div>
      </div>
    );
  }
}
export default DynamicTabs;
